import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faChevronDown, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import "./EditAve.css";
import "../Edit.css"; // Importar el archivo CSS compartido

const EditAve = () => {
  const { id } = useParams(); // Get the ave ID from the route parameters
  const navigate = useNavigate();
  const [ave, setAve] = useState({
    especie: "",
    nombre: "",
    fecha_recepcion: "",
    cantidad_inicial: "",
    edad_llegada: "",
    edad_actual: "", // Este campo se actualizará dinámicamente
    saldo: "", // Nuevo campo editable
    id_alimento: "",
    ingesta_diaria: "",
    mortalidad: "",
    galponId: "",
    granjaId: ""
  });
  const [error, setError] = useState("");
  const [openSection, setOpenSection] = useState(null); // Controlar qué sección está abierta

  useEffect(() => {
    // Fetch the ave details by ID and populate the form
    axios
      .get(`${process.env.REACT_APP_API_URL}/aves/${id}`)
      .then((response) => {
        setAve(response.data);
      })
      .catch((error) => {
        console.error("Error fetching ave details:", error);
        setError("Failed to load ave details.");
      });
  }, [id]);

  // Función para calcular la edad actual en semanas
  const calculateAge = (fechaRecepcion) => {
    const fechaRecepcionDate = new Date(fechaRecepcion);
    const today = new Date();
    const timeDifference = today - fechaRecepcionDate; // Diferencia en milisegundos
    const ageInWeeks = Math.floor(timeDifference / (1000 * 60 * 60 * 24 * 7)); // Convertir a semanas
    return ageInWeeks;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Si el campo que cambia es la fecha de recepción, recalcular la edad actual
    if (name === "fecha_recepcion") {
      const edad_actual = calculateAge(value); // Calcular la edad en semanas
      setAve((prevData) => ({
        ...prevData,
        [name]: value,
        edad_actual, // Actualizar la edad actual automáticamente
      }));
    } else {
      setAve((prevData) => ({ ...prevData, [name]: value }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    axios
      .put(`${process.env.REACT_APP_API_URL}/aves/${id}`, ave)
      .then((response) => {
        console.log("Ave updated successfully:", response.data);
        navigate("/mis-aves"); // Navigate back to the list of aves
      })
      .catch((error) => {
        console.error("Error updating ave:", error);
        setError("Failed to update ave.");
      });
  };

  const toggleSection = (section) => {
    setOpenSection((prev) => (prev === section ? null : section)); // Alternar sección
  };

  return (
    <div className="edit-container">
      <button onClick={() => navigate(-1)} className="btn btn-back">
        <FontAwesomeIcon icon={faChevronLeft} /> Volver
      </button>
      <h1 className="flex-space-between">
        {ave?.nombre} <span className="IdEditContainer"> id: {ave?.id}</span>{" "}
      </h1>{" "}
      {error && <p className="error-message">{error}</p>}
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Especie:</label>
          <input
            type="text"
            name="especie"
            value={ave.especie}
            onChange={handleChange}
          />
        </div>
        <div className="form-group">
          <label>Nombre:</label>
          <input
            type="text"
            name="nombre"
            value={ave.nombre}
            onChange={handleChange}
          />
        </div>
        <div className="form-group">
          <label>Fecha de Recepción:</label>
          <input
            type="date"
            name="fecha_recepcion"
            value={ave.fecha_recepcion}
            onChange={handleChange}
          />
        </div>
        <div className="form-group">
          <label>Edad Actual (semanas):</label>
          <input
            type="number"
            name="edad_actual"
            value={ave.edad_actual} // Mostrar la edad calculada
            readOnly
          />
        </div>

        <div className="form-group">
          <label>Cantidad de Aves (Saldo):</label>
          <input
            type="number"
            name="saldo"
            value={ave.saldo}
            onChange={handleChange}
          />
        </div>

        <button type="submit" className="btn btn-primary">Guardar Cambios</button>
      </form>

      {/* Sección de Control Aves */}
      <div className="control-section">
        <div
          className="section-header"
          onClick={() => toggleSection("controlAves")}
        >
          <FontAwesomeIcon
            icon={openSection === "controlAves" ? faChevronDown : faChevronRight}
          />{" "}
          Control Aves
        </div>
        {openSection === "controlAves" && (
          <div className="section-content">
            {/* Aquí incluirías el componente o los datos de control de aves */}
            <p>Información de control de aves (alimentación, mortalidad, etc.)</p>
          </div>
        )}
      </div>

      {/* Sección de Producción Huevos */}
      <div className="control-section">
        <div
          className="section-header"
          onClick={() => toggleSection("produccionHuevos")}
        >
          <FontAwesomeIcon
            icon={openSection === "produccionHuevos" ? faChevronDown : faChevronRight}
          />{" "}
          Producción de Huevos
        </div>
        {openSection === "produccionHuevos" && (
          <div className="section-content">
            {/* Aquí incluirías el componente o los datos de producción de huevos */}
            <p>Información de la producción de huevos.</p>
          </div>
        )}
      </div>

      {/* Sección de Control Alimentos */}
      <div className="control-section">
        <div
          className="section-header"
          onClick={() => toggleSection("controlAlimentos")}
        >
          <FontAwesomeIcon
            icon={openSection === "controlAlimentos" ? faChevronDown : faChevronRight}
          />{" "}
          Control de Alimentos
        </div>
        {openSection === "controlAlimentos" && (
          <div className="section-content">
            {/* Aquí incluirías el componente o los datos de control de alimentos */}
            <p>Información del control de alimentos.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default EditAve;
